var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SchematicTerminal = require("./schematicTerminal.js");

var SchematicNetData = function () {
    var self = this;

    this.makeObservableTreeNode();

    this.terminals = this.set("terminals", false);
    this.segments = this.set("segments", true);
    this.dots = this.set("dots", true);

    this.terminals.onRemove("remove Net", function(){
        if (this.size() <= 1 && self.isAlive()) self.remove();
    });

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(precision){
            var segmentGeometries = self.segments.map(function (seg) {
                return seg.segmentedGeometry(precision);
            }).toArray();
            return new lib_geometry.MultiPolygon(lib_geometry.Union(segmentGeometries));
        },
        [[this.segments, this.segments.onBubble]]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return self.segmentedGeometry().getBB(); },
        [this.segmentedGeometry]
    );
};
lib_core.mixin(SchematicNetData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(SchematicNetData, "SchematicNetData");

module.exports = SchematicNetData;

SchematicNetData.prototype.logicNet = function() {
    var logic_terminal;
    this.terminals.forEach(function(schematicTerminal) {
        logic_terminal = logic_terminal || schematicTerminal.logicTerminal;
    });
    return logic_terminal && logic_terminal.net();
};

SchematicNetData.prototype.mergeNet = function(net) {
    if (net != this) {
        var terminals = net.terminals.copy();
        net.remove();
        this.terminals.addAll(terminals);
    }
};

SchematicNetData.prototype.terminalBoundingBox = function() {
    var terminal_posses = this.terminals.toArray().map(function(term) {return term.pos();});
    return new lib_geometry.PointSet(terminal_posses).getBB();
};

SchematicNetData.prototype.sanityCheck = function() {
    lib_core.ObservableTreeNode.sanityCheck.call(this);
    var self = this;
    var logic_net = self.logicNet();
    self.terminals.forEach(function(schematicTerminal) {
        console.assert(schematicTerminal.net() === self, "All the net's terminals should refer to 'this' as their net");
        if(logic_net && schematicTerminal.logicTerminal)//schematicterminal may be unmapped
            console.assert(schematicTerminal.logicTerminal.net() === logic_net, "All the net's logic terminals should point to one logic net");
    });
};
